import React, { useState } from "react";
import { observer } from "mobx-react";
import { Grid2 } from "@mui/material";
import { useStores } from "../../../use-stores";
import { EmployeeRoles } from "../../../../../models/Employees/EmployeeRoles";
import PermissionBlockLabel from "../../../../../views/components/common/pop-up/PermissionBlockLabel ";
import LoaderOverlay from "../../../../../views/components/common/pages/AppLoader";
import { NewOperationsDashboardStore } from "../../../stores/dashboards/NewOperationsDashboardStore";
import OpsTatFilters from "../../components/dashboard/ops-tat/OpsTatFilters";
import OpsTatDaysLedger from "../../components/dashboard/ops-tat/OpsTatDaysLedger";
import OpsTatStageGrid from "../../components/dashboard/ops-tat/OpsTatStageGrid";
import OpsTatDispatchBlock from "../../components/dashboard/ops-tat/OpsTatDispatchBlock";
import OpsInwardDeviation from "../../components/dashboard/ops-tat/OpsInwardDeviation";
import OpsTatDrilldownDrawer from "../../components/dashboard/ops-tat/OpsTatDrilldownDrawer";

const NewOperationsDashboardView: React.FC = observer(() => {
  const [store] = useState(() => new NewOperationsDashboardStore());

  return (
    <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={{ px: 2 }}>
      <LoaderOverlay loading={store.summaryLoading} />
      <OpsTatFilters store={store} />
      <OpsTatDaysLedger store={store} />
      <OpsTatStageGrid store={store} />
      <OpsTatDispatchBlock store={store} />
      <OpsInwardDeviation store={store} />
      <OpsTatDrilldownDrawer store={store} />
    </Grid2>
  );
});

const NewOperationsDashboard: React.FC = () => {
  const { userStore } = useStores();

  if (!userStore.hasPermission(EmployeeRoles.VIEW_OPS_DASHBOARD)) {
    return <PermissionBlockLabel />;
  }

  return <NewOperationsDashboardView key="ops-vendor-page-size-10" />;
};

export default observer(NewOperationsDashboard);
